import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy admin edit URL: /$toolId/edit → the admin tools editor (which enforces the admin role).
export const Route = createFileRoute('/$toolId/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/admin/tools', search: { edit: params.toolId } })
  },
})
